/* AURALIFE theme — interactions (vanilla JS, no build step) */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = document.getElementById('mobile-menu');
      if (menu) menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      var menu = document.getElementById('mobile-menu');
      if (menu) menu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  /* ---------- Accordion (product page) ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.accordion-item');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      item.parentElement.querySelectorAll('.accordion-item').forEach(function (i) {
        i.classList.remove('is-open');
      });
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        if (mainImg && src) mainImg.src = src;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Quantity selector ---------- */
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-qty-decrease]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
        input.dispatchEvent(new Event('change'));
      });
    });
    wrap.querySelectorAll('[data-qty-increase]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
        input.dispatchEvent(new Event('change'));
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('cart-drawer');

  function openCartDrawer() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCartDrawer().then(openCartDrawer);
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCartDrawer);
  });

  function refreshCartDrawer() {
    return fetch('/cart?view=drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.getElementById('cart-drawer');
        if (fresh && cartDrawer) {
          cartDrawer.innerHTML = fresh.innerHTML;
          bindCartDrawerEvents();
          var count = document.querySelector('[data-cart-count-drawer]');
          if (count) updateGiftProgress(parseInt(count.textContent, 10) || 0);
        }
        updateCartCount();
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  function bindCartDrawerEvents() {
    if (cartDrawer) {
      cartDrawer.querySelectorAll('[data-cart-close]').forEach(function (el) {
        el.addEventListener('click', closeCartDrawer);
      });
    }
  }

  function isInDrawer(el) {
    return !!(cartDrawer && cartDrawer.contains(el));
  }

  /* ---------- Upsell add-to-cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn || btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function () { return refreshCartDrawer(); })
      .catch(function () {})
      .finally(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  /* ---------- Gift progress ---------- */
  function updateGiftProgress(itemCount) {
    var wrap = document.querySelector('[data-gift-progress]');
    if (!wrap) return;
    var raw = wrap.getAttribute('data-milestones');
    var milestones;
    try { milestones = JSON.parse(raw); } catch (e) { return; }
    if (!Array.isArray(milestones) || !milestones.length) return;

    milestones.sort(function (a, b) { return a.quantity - b.quantity; });
    var maxQty = milestones[milestones.length - 1].quantity;
    var pct = Math.min(100, Math.round(itemCount * 100 / maxQty));

    var bar = wrap.querySelector('[data-gift-bar]');
    if (bar) bar.style.width = pct + '%';

    wrap.querySelectorAll('[data-milestone-qty]').forEach(function (step) {
      var qty = parseInt(step.getAttribute('data-milestone-qty'), 10);
      step.classList.toggle('is-reached', itemCount >= qty);
    });

    var msgEl = wrap.querySelector('[data-gift-message]');
    if (!msgEl) return;
    var next = milestones.find(function (m) { return itemCount < m.quantity; });
    if (next) {
      var rem = next.quantity - itemCount;
      msgEl.innerHTML = 'Add <strong>' + rem + ' ' + (rem === 1 ? 'item' : 'items') + '</strong> to earn <strong>' + next.label + '</strong>! 🎁';
    } else {
      msgEl.innerHTML = '🎉 You unlocked all gifts!';
    }
  }

  /* ---------- Cart line update ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-remove], [data-line-decrease], [data-line-increase]');
    if (!btn) return;
    var line = btn.getAttribute('data-line');
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 0;
    var quantity = 0;
    if (btn.hasAttribute('data-line-decrease')) quantity = Math.max(0, qty - 1);
    else if (btn.hasAttribute('data-line-increase')) quantity = qty + 1;
    else quantity = 0;
    updateLine(line, quantity, isInDrawer(btn));
  });

  function updateLine(line, quantity, inDrawer) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function () {
        if (inDrawer) {
          return refreshCartDrawer();
        }
        window.location.reload();
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-add-to-cart]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-loading-text') || originalText;
      }
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          return refreshCartDrawer();
        })
        .then(function () {
          openCartDrawer();
        })
        .catch(function () {
          window.location.href = '/cart';
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        });
    });
  });

  updateCartCount();
  bindCartDrawerEvents();

  /* ---------- Search dialog ---------- */
  var searchDialog = document.getElementById('search-dialog');
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchDialog) {
        searchDialog.classList.add('is-open');
        var input = searchDialog.querySelector('input[type="search"]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      }
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (searchDialog) searchDialog.classList.remove('is-open');
    });
  });

  var searchInput = document.getElementById('predictive-search-input');
  var searchResults = document.getElementById('predictive-search-results');
  var searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="cart-empty">' + (searchResults.getAttribute('data-empty-text') || 'No products found.') + '</p>';
              return;
            }
            searchResults.innerHTML = products
              .map(function (p) {
                var img = p.featured_image ? p.featured_image.url : '';
                return (
                  '<a href="' + p.url + '">' +
                  (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                  '<span>' + p.title + '</span>' +
                  '</a>'
                );
              })
              .join('');
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Escape key closes overlays ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      if (searchDialog) searchDialog.classList.remove('is-open');
      var menu = document.getElementById('mobile-menu');
      if (menu) menu.classList.remove('is-open');
    }
  });

})();

/* PRODUCT PAGE v2 */
(function () {
  'use strict';

  /* ---------- Countdown ---------- */
  document.querySelectorAll('[data-flash-countdown]').forEach(function (el) {
    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var end = Date.now() + minutes * 60 * 1000;
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var m = Math.floor(diff / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (diff <= 0) { clearInterval(timer); }
    }
    tick();
    var timer = setInterval(tick, 1000);
  });

  /* ---------- Delivery timeline ---------- */
  document.querySelectorAll('[data-delivery-timeline]').forEach(function (wrap) {
    var monthsEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function fmt(d) { return monthsEn[d.getMonth()] + ' ' + d.getDate(); }
    function addDays(base, days) {
      var d = new Date(base);
      d.setDate(d.getDate() + days);
      return d;
    }
    var today = new Date();
    wrap.querySelectorAll('[data-step]').forEach(function (step) {
      var minD = parseInt(step.getAttribute('data-min-days'), 10) || 0;
      var maxD = step.getAttribute('data-max-days') ? parseInt(step.getAttribute('data-max-days'), 10) : null;
      var dateEl = step.querySelector('[data-step-date]');
      if (!dateEl) return;
      if (maxD !== null && maxD !== minD) {
        dateEl.textContent = fmt(addDays(today, minD)) + ' – ' + fmt(addDays(today, maxD));
      } else {
        dateEl.textContent = fmt(addDays(today, minD));
      }
    });
  });

  /* ---------- Bundle tiers ---------- */
  document.querySelectorAll('[data-bundle-wrapper]').forEach(function (wrap) {
    var qtyInput = wrap.querySelector('[data-bundle-qty-target]');
    var totalEl = wrap.querySelector('[data-bundle-total]');
    var addonCheckbox = wrap.querySelector('[data-addon-checkbox]');
    var addonPrice = addonCheckbox ? parseFloat(addonCheckbox.getAttribute('data-addon-price') || '0') : 0;

    function updateTotal() {
      var checked = wrap.querySelector('input[name="bundle-tier"]:checked');
      var unitPrice = checked ? parseFloat(checked.getAttribute('data-unit-total') || '0') : 0;
      var qty = checked ? parseInt(checked.getAttribute('data-qty'), 10) : 1;
      if (qtyInput) qtyInput.value = qty;
      var total = unitPrice;
      if (addonCheckbox && addonCheckbox.checked) total += addonPrice;
      if (totalEl) totalEl.textContent = formatMoney(total);
    }

    function formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2);
    }

    wrap.querySelectorAll('input[name="bundle-tier"]').forEach(function (radio) {
      radio.addEventListener('change', updateTotal);
    });
    if (addonCheckbox) addonCheckbox.addEventListener('change', updateTotal);
    updateTotal();
  });

  /* ---------- Spec cards ---------- */
  document.querySelectorAll('[data-spec-card]').forEach(function (card) {
    card.addEventListener('click', function () {
      card.classList.toggle('is-open');
      var toggle = card.querySelector('[data-spec-toggle]');
      if (toggle) toggle.textContent = card.classList.contains('is-open') ? '−' : '+';
    });
  });

  /* ---------- Wishlist ---------- */
  document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
    var id = btn.getAttribute('data-product-id');
    var key = 'wishlist';
    function getList() {
      try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return []; }
    }
    function setActive() {
      var list = getList();
      btn.classList.toggle('is-active', list.indexOf(id) !== -1);
    }
    setActive();
    btn.addEventListener('click', function () {
      var list = getList();
      var idx = list.indexOf(id);
      if (idx === -1) list.push(id); else list.splice(idx, 1);
      localStorage.setItem(key, JSON.stringify(list));
      setActive();
    });
  });

  /* ---------- Buy now ---------- */
  document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      var formData = new FormData(form);
      var items = [{
        id: formData.get('id'),
        quantity: formData.get('quantity') || 1,
      }];
      var addonCheckbox = form.querySelector('[data-addon-checkbox]');
      if (addonCheckbox && addonCheckbox.checked) {
        items.push({
          id: addonCheckbox.getAttribute('data-addon-variant-id'),
          quantity: 1,
        });
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { window.location.href = '/cart'; });
    });
  });

  /* ---------- Add to bag with addon ---------- */
  document.querySelectorAll('[data-product-form-with-addon]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var addonCheckbox = form.querySelector('[data-addon-checkbox]');
      if (!addonCheckbox || !addonCheckbox.checked) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var formData = new FormData(form);
      var items = [{ id: formData.get('id'), quantity: formData.get('quantity') || 1 }];
      items.push({ id: addonCheckbox.getAttribute('data-addon-variant-id'), quantity: 1 });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function () { return refreshCartDrawer(); })
        .then(function () { openCartDrawer(); })
        .catch(function () {});
    });
  });

})();

/* ==========================================================================
   CATÁLOGO COM FILTRO POR TAG
   ========================================================================== */
(function () {
  'use strict';
  document.querySelectorAll('[data-catalog-filters]').forEach(function (filterBar) {
    var grid = filterBar.parentElement.querySelector('[data-catalog-grid]');
    if (!grid) return;
    var items = grid.querySelectorAll('[data-catalog-item]');

    filterBar.querySelectorAll('[data-catalog-filter]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-catalog-filter');
        filterBar.querySelectorAll('[data-catalog-filter]').forEach(function (b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        items.forEach(function (item) {
          if (tag === 'all') {
            item.classList.remove('is-filtered-out');
            return;
          }
          var tags = (item.getAttribute('data-tags') || '').split(',');
          if (tags.indexOf(tag) !== -1) {
            item.classList.remove('is-filtered-out');
          } else {
            item.classList.add('is-filtered-out');
          }
        });
      });
    });
  });
})();
